const CE_LOB_MAP = {
  PA: 'Personal Auto',
  WC: 'Works Comp',
}

export default CE_LOB_MAP